import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarDetailPasien from "../../components/TobBarDetailPasien";
import EditDetailPasienTK from "../../components/EditDetailPasienTK";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanDataPasienTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarDetailPasien />

        {/* Konten utama */}
        <div className="detailpasien-page">
          <EditDetailPasienTK />
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPasienTenagaKesehatan;
